export default {
  getInvitation: state => {
    return state.invitation
  },
  getError: state => {
    return state.error;
  },
}
